import api from "./index";

export const getDocumentsService = async (params) =>
  await api.get("/event-file", { params });

export const getFileService = async (id) =>
  await api.get(`/event-file/${id}?action=VIEW`);
